import { Link } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export const UpgradeGate = ({ feature = "This feature", desc, testid = "upgrade-gate" }) => (
  <div className="flex flex-col items-center justify-center text-center py-16 px-6 rounded-2xl border border-dashed border-border bg-card" data-testid={testid}>
    <div className="h-14 w-14 rounded-2xl brand-gradient flex items-center justify-center text-white mb-5">
      <Lock size={24} />
    </div>
    <h3 className="font-heading font-bold text-xl">{feature} is a Pro feature</h3>
    <p className="text-muted-foreground mt-2 max-w-md">
      {desc || `Upgrade to the Pro or Club plan to unlock ${feature.toLowerCase()}.`}
    </p>
    <Button asChild className="mt-6 brand-gradient text-white border-0 hover:opacity-90" data-testid="upgrade-gate-btn">
      <Link to="/app/payments">
        <Sparkles size={16} className="mr-2" /> Upgrade to unlock
      </Link>
    </Button>
  </div>
);
